import 'promise-polyfill';
import 'whatwg-fetch';
import 'es6-object-assign/auto';
import 'promise-polyfill/src/polyfill';
